import { createElement } from 'react';

/** Keep consecutive spaces visible (browser default collapses them). */
export const PRESERVE_WHITESPACE_SX = {
  whiteSpace: 'pre',
};

/** Single-line ellipsis while preserving spaces (use instead of nowrap). */
export const PRESERVE_WHITESPACE_ELLIPSIS_SX = {
  whiteSpace: 'pre',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

/** MUI Tooltip string titles collapse spaces; pass a pre-wrapped node instead. */
export const preserveWhitespaceTitle = (text) => {
  if (text == null || text === '') return text;
  return createElement('span', { style: { whiteSpace: 'pre' } }, String(text));
};
